export enum StorePickupInfoFormFields {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  PHONE_NO = 'phoneNumber',
}

export const StorePickupInfoFormInitialState = {
  [StorePickupInfoFormFields.FIRST_NAME]: '',
  [StorePickupInfoFormFields.LAST_NAME]: '',
  [StorePickupInfoFormFields.PHONE_NO]: '',
};
